import React from 'react'

export const PageNavigation = ({children, ...props}) => {

    return (
        <nav {...props}>
            {children}
        </nav>
    )
}  